import { render, staticRenderFns } from "./NewYear.vue?vue&type=template&id=1829ed30&scoped=true&"
import script from "./NewYear.vue?vue&type=script&lang=js&"
export * from "./NewYear.vue?vue&type=script&lang=js&"
import style0 from "./NewYear.vue?vue&type=style&index=0&id=1829ed30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829ed30",
  null
  
)

export default component.exports